import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useConfigStore } from "@/stores/config";
import { createToaster } from "@meforma/vue-toaster";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "داشبورد",
          breadcrumbs: ["داشبورد"],
        },
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/LayoutBuilder.vue"),
        meta: {
          pageTitle: "سازنده لایوت",
          breadcrumbs: ["سازنده لایوت"],
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/crafted/account/Settings.vue"),
        meta: {
          pageTitle: "سازنده لایوت",
          breadcrumbs: ["سازنده لایوت"],
          roles: ["reporter", "admin", "warehouse-keeper"],
        },
      },
      {
        path: "/financial",
        name: "financial",

        meta: {
          breadcrumbs: ["گزارشات"],
          pageTitle: "گزارشات",
          roles: ["reporter", "super admin", "marketing"],
        },
        children: [
          {
            path: "transactions",
            name: "transactionsList",
            component: () => import("@/views/financial/transactionsList.vue"),
            meta: {
              pageTitle: "لیست تراکنش ها",
              breadcrumbs: ["مالی"],
              roles: ["super admin"],
            },
          },
          {
            path: "debtlList",
            name: "debtlList",
            component: () => import("@/views/financial/debtList.vue"),
            meta: {
              pageTitle: " لیست بدهکاری ها ",
              breadcrumbs: ["مالی"],
              roles: ["admin", "super admin", "financial admin"],
            },
          },
        ]
      },
      {
        path: "/report",
        name: "reports",

        meta: {
          breadcrumbs: ["گزارشات"],
          pageTitle: "گزارشات",
          roles: ["reporter", "super admin",'admin', "marketing"],
        },

        children: [
          {
            path: "financial",
            name: "financialReport",
            component: () => import("@/views/Report/financial-transaction.vue"),
            meta: {
              pageTitle: " مالی",
              breadcrumbs: ["گزارشات سازمانی"],
              roles: ["reporter", "super admin"],
            },
          },
          {
            path: "financialList",
            name: "financialList",
            component: () => import("@/views/Report/financial.vue"),
            meta: {
              pageTitle: "گزارش مالی",
              breadcrumbs: ["مالی"],
              roles: ["admin", "super admin", "financial admin"],
            },
          },
          {
            path: "user",
            name: "userReport",

            component: () => import("@/views/Report/user.vue"),
            meta: {
              pageTitle: " کاربران",
              breadcrumbs: ["گزارشات سازمانی"],
              roles: ["reporter", "super admin"],
            },
          },
          {
            path: "order",
            name: "orderReport",
            component: () => import("@/views/Report/order.vue"),
            meta: {
              pageTitle: " سفارشات ",
              breadcrumbs: ["گزارشات سازمانی"],
              roles: ["reporter", "super admin"],
            },
          },
          {
            path: "daily-order",
            name: "dailyOrderReport",
            component: () => import("@/views/Report/dailyOrder.vue"),
            meta: {
              pageTitle: "گزارش سفارشات",
              roles: ["reporter", "super admin", "marketing"],
              breadcrumbs: ["سفارشات"],
            },
          },
          {
            path: "logs-report",
            name: "logs-report",
            component: () => import("@/views/afta/LogsList.vue"),
            meta: {
              pageTitle: "گزارش لاگ",
              breadcrumbs: ["گزارش های عملکرد"],
              roles: ["super admin"],
            },
          },
          {
            path: "recycle-items",
            name: "recycleItemsReport",
            component: () => import("@/views/waste/Report.vue"),
            meta: {
              pageTitle: "گزارش پسماند های جمع اوری شده",
              breadcrumbs: ["گزارش های عملکرد"],
              roles: ["admin", "super admin", "marketing",'financial admin'],
            },
          },
          {
            path: "price-list-report",
            name: "priceListReport",
            component: () => import("@/views/waste/priceListReport.vue"),
            meta: {
              pageTitle: "گزارش پسماند های قراردادی",
              breadcrumbs: ["گزارش های عملکرد"],
              roles: [ "super admin", "operator"],
            },
          },
          {
            path: "report-map",
            name: "reports-map",
            component: () => import("@/views/drivers/DriverLocation.vue"),
            meta: {
              pageTitle: "موقیعیت مکانی خودرو ها ",
              breadcrumbs: ["نقشه"],
              roles: ["super admin", "reporter"],
            },
          },
        ],
      },
      {
        path: "/users",
        name: "users",
        meta: {
          breadcrumbs: ["کاربران"],
          pageTitle: "کاربران",
          roles: ["admin", "operator", "super admin"],
        },
        children: [
          {
            path: "",
            name: "userList",
            component: () => import("@/views/User/List.vue"),
            meta: {
              pageTitle: "لیست کاربران",
              roles: ["admin", "operator", "super admin"],
              breadcrumbs: ["مدیریت کاربران"],
            },
          },

          {
            path: "/users/:id",
            name: "profile-overview",
            component: () => import("@/views/User/Detail.vue"),
            meta: {
              pageTitle: "مشخصات کاربر",
              breadcrumbs: ["جزئیات کاربر"],
            },
          },
          {
            path: "/users/edit/:id",
            name: "editUser",
            component: () => import("@/views/User/Edit.vue"),
            meta: {
              pageTitle: "ویرایش کاربر ",
              breadcrumbs: ["ویرایش"],
            },
          },



          {
            path: "/users/Address/edit/:id",
            name: "editAddressUser",
            component: () => import("@/views/address/EditAddress.vue"),
            meta: {
              pageTitle: "ویرایش ادرس کاربر ",
              breadcrumbs: ["ادرس"],
              props: true

            },
          },





          {
            path: "/users/add",
            name: "addUser",
            component: () => import("@/views/User/Add.vue"),
            meta: {
              pageTitle: "افزودن کاربر ",
              breadcrumbs: ["مدیریت کاربران "],
              roles: ["super admin", "admin", "operator"],
            },
          },
        ],
      },
      {
        path: "/home",
        name: "homePage",
        component: () => import("@/views/Home.vue"),
        meta: {
          pageTitle: "",
          roles: [
            "super admin",
            "admin",
            "operator",
            "reporter",
            "marketing",
            "warehouse-keeper",
          ],
          breadcrumbs: [""],
        },
      },
      {
        path: "/DriverList",
        name: "driverList",
        component: () => import("@/views/drivers/DriversList.vue"),
        meta: {
          pageTitle: "لیست رانندگان",
          roles: ["admin", "driver admin", "warehouse-keeper"],
          breadcrumbs: ["کاربران"],
        },
      },
      {
        path: "/transactions",
        name: "transactions",
        meta: {
          breadcrumbs: ["تراکنش ها"],
          pageTitle: "تراکنش ها",
          roles: ["admin", "operator", "super admin", "financial admin"],
        },
        component: () => import("@/views/transactions/List.vue"),
      },
      {
        path: "/orders",
        name: "orders",
        meta: {
          breadcrumbs: ["سفارشات"],
          pageTitle: " سفارشات",
        },
        children: [
          {
            path: "requestMap",
            name: "requestMap",
            component: () => import("@/views/maps/RequestMap.vue"),
            meta: {
              pageTitle: " نقشه سفارشات",
              roles: ["admin", "super admin", "operator" ,'driver admin'],
            },
          },
          {
            path: "",
            name: "ordersList",
            component: () => import("@/views/Order/List.vue"),
            meta: {
              pageTitle: "سفارشات",
              roles: ["admin", "operator", "super admin"],
            },
          },
          {
            path: "daily-order-report",
            name: "dailyOrderReportOrder",
            component: () => import("@/views/Report/dailyOrder.vue"),
            meta: {
              pageTitle: "گزارش سفارشات",
              roles: ["super admin",'operator',"driver admin"],
              breadcrumbs: ["سفارشات"],
            },
          },
          {
            path: ":id",
            name: "ordersDetail",
            component: () => import("@/views/Order/Detail.vue"),
            meta: {
              pageTitle: "جزئیات سفارش",
              breadcrumbs: ["جزئیات"],
              roles: ["admin", "operator", "marketing"],
            },
          },
          {
            path: "cancelOrder",
            name: "cancelOrder",
            component: () => import("@/views/Order/Cancel.vue"),
            meta: {
              pageTitle: "سفارشات",
              breadcrumbs: ["کنسلی سفارش"],
              roles: ["admin", "operator", "marketing", "super admin"],
            },
          },
          {
            path: "edit/:id",
            name: "ordersEdit",
            component: () => import("@/views/Order/Edit.vue"),
            meta: {
              pageTitle: "ویرایش سفارش",
              breadcrumbs: ["ویرایش"],
              roles: ["admin", "operator", "warehouse-keeper"],
            },
          },
          {
            path: "phone/",
            name: "phoneOrders",
            component: () => import("@/views/Order/phone-order.vue"),
            meta: {
              pageTitle: "ثبت سفارش تلفنی",
              breadcrumbs: ["ثبت سفارش تلفنی"],
              roles: ["admin", "operator", "super admin"],
            },
          },
          {
            path: "user-phone/:user_id",
            name: "user-phone-order",
            component: () => import("@/views/Order/userPhoneOrder.vue"),
            meta: {
              pageTitle: "ثبت سفارش تلفنی",
              breadcrumbs: ["ثبت سفارش تلفنی"],
            },
          },
          {
            path: "needs-confirmation",
            name: "ordersNeedsConfirmationList",
            component: () => import("@/views/Order/List.vue"),
            meta: {
              pageTitle: "سفارشات نیازمند تایید",
              roles: [
                "admin",
                "operator",
                "super admin",
                ///        enums.roles.OPERATOR.value,
                ///        enums.roles.ADMIN.value,
                ///        enums.roles.SUPER_ADMIN.value,
              ],
            },
          },
          //// under dev
          {
            path: "orderTime",
            name: "orderTime",
            component: () => import("@/views/availableCars/orderTime.vue"),
            meta: {
              pageTitle: "ظرفیت روزانه راننده ها ",
              breadcrumbs: ["ظرفیت خودرو ها"],
              roles: ["admin", "super admin", "operator"],
            },
          },
          {
            path: "orderTimeDetail",
            name: "orderTimeDetail",
            component: () =>
                import("@/views/availableCars/orderTimeDetail.vue"),
            meta: {
              pageTitle: "سفارشات روزانه راننده  ",

              roles: ["admin", "super admin", "marketing", "operator"],
            },
          },
        ],
      },
      // {
      //   path: "/requests",
      //   name: "requests",
      //   meta: {
      //     breadcrumbs: [""],
      //     pageTitle: "درخواست ها",
      //   },
      //   children: [
      //     {
      //       path: "",
      //       name: "requestsList",
      //       component: () => import("@/views/requests/List.vue"),
      //       meta: {
      //         pageTitle: "لیست درخواست ها",
      //         breadcrumbs: [""],
      //       },
      //     },
      //     {
      //       path: "/:id",
      //       name: "requestsDetail",
      //       component: () => import("@/views/requests/Detail.vue"),
      //       meta: {
      //         pageTitle: "جزئیات سفارش",
      //         breadcrumbs: ["جزئیات"],
      //       },
      //     },
      //     {
      //       path: "edit",
      //       name: "requestsEdit",
      //       component: () => import("@/views/requests/Edit.vue"),
      //       meta: {
      //         pageTitle: "ویرایش سفارش",
      //         breadcrumbs: ["ویرایش"],
      //       },
      //     },
      //   ],
      // },
      {
        path: "/inventory-waste-storehouse",
        name: "storehouseWaste",
        meta: {
          breadcrumbs: ["پسماندهای داخل انبار"],
          pageTitle: " پسماندهای داخل انبار",
          roles: ["warehouse-keeper"],
        },
        children: [
          {
            path: "",
            name: "storehouseWasteList",
            component: () => import("@/views/waste/StorehouseWasteList.vue"),
            meta: {
              pageTitle: "پسماندهای داخل انبار",
            },
          },
        ],
      },
      {
        path: "/waste",
        name: "waste",
        meta: {
          breadcrumbs: ["پسماندها"],
          pageTitle: " پسماند ها",
          roles: ['super admin',"admin", "operator", "marketing",'financial admin'],
        },
        children: [
          {
            path: "/wasteList",
            name: "wasteList",
            component: () => import("@/views/waste/List.vue"),
            meta: {
              pageTitle: "لیست پسماندها",
              roles: [
                "super admin",
                "reporter",
                "admin",
                "operator",
                "marketing",
                "warehouse-keeper",
                'financial admin',
              ],
            },
          },
          {
            path: "/wastePriceList",
            name: "wastePriceList",
            component: () => import("@/views/waste/PriceList.vue"),
            meta: {
              pageTitle: "نرخ های ویژه",
              roles: [
                "super admin",
                "reporter",
                "admin",
                "operator",
                "marketing",
                "warehouse-keeper",
                'financial admin',
              ],
            },
          },
          {
            path: "addWaste/:id?",
            name: "wastePriceListAdd",
            component: () => import("@/views/waste/PriceListAdd.vue"),
            meta: {
              pageTitle: "افزودن پسماند قراردادی",
              breadcrumbs: ["افزودن"],
            },
          },
          {
            path: "editWaste/:recycle_item_id/:user_id",
            name: "wastePriceListEdit",
            component: () => import("@/views/waste/PriceListEdit.vue"),
            meta: {
              pageTitle: "ویرایش پسماند قراردادی",
              breadcrumbs: ["ویرایش"],
            },
          },
          {
            path: "add",
            name: "wasteListAdd",
            component: () => import("@/views/waste/Add.vue"),
            meta: {
              pageTitle: "افزودن پسماند",
              breadcrumbs: ["افزودن"],
            },
          },
          {
            path: "add",
            name: "wasteListAddCategory",
            component: () => import("@/views/waste/Add.vue"),
            meta: {
              pageTitle: "افزودن پسماند",
              breadcrumbs: ["افزودن"],
            },
          },
          {
            path: "edit/:id:pid:cityId",
            name: "wasteListEdit",
            component: () => import("@/views/waste/Edit.vue"),
            meta: {
              pageTitle: "ویرایش پسماند",
              breadcrumbs: ["ویرایش"],
            },
          },
        ],
      },
      {
        path: "/delivery",
        name: "delivery",
        meta: {
          breadcrumbs: ["تحویلی ها"],
          pageTitle: "تحویلی ها",
          roles: ["super admin", "admin", "warehouse-keeper","reporter"],
        },
        children: [
          {
            path: "",
            name: "deliveryList",
            component: () => import("@/views/delivery/List.vue"),
            meta: {
              pageTitle: "لیست تحویلی ها",
              roles: ["super admin", "admin", "warehouse-keeper", "reporter"],
            },
          },
          {
            path: "/add",
            name: "addDelivery",
            component: () => import("@/views/delivery/Add.vue"),
            meta: {
              pageTitle: " ثبت تحویل به انبار",
              roles: ["super admin", "admin", "warehouse-keeper"],
            },
          },
          {
            path: "/DriverList",
            name: "addDeliveryShortCut",
            component: () => import("@/views/drivers/DriversList.vue"),
            meta: {
              pageTitle: " ثبت تحویل به انبار",

              roles: ["super admin", "admin", "warehouse-keeper"],
            },
          },
        ],
      },
      {
        path: "/outputs",
        name: "outputs",
        meta: {
          breadcrumbs: ["خروجی ها"],
          pageTitle: "خروجی ها",
          roles: ["super admin", "admin", "warehouse-keeper","reporter"],
        },
        children: [
          {
            path: "",
            name: "outputsList",
            component: () => import("@/views/outputs/List.vue"),
            meta: {
              breadcrumbs: [" خروجی ها"],
              pageTitle: "لیست خروجی ها",
              roles: ["super admin", "admin", "warehouse-keeper","reporter"],
            },
          },
          {
            path: "/logOutput",
            name: "logOutput",
            component: () => import("@/views/outputs/LogOutput.vue"),
            meta: {
              pageTitle: "   ثبت خروجی از انبار ",
              breadcrumbs: ["خروجی ها"],
              roles: ["super admin", "admin", "warehouse-keeper"],
            },
          },
        ],
      },
      {
        path: "/address",
        name: "address",
        meta: {
          breadcrumbs: ["آدرس ها"],
          pageTitle: "ادرس ها",
          roles: ["admin", "super admin", "operator"],
        },
        children: [
          {
            path: "",
            name: "addressList",
            component: () => import("@/views/address/List.vue"),
            meta: {
              breadcrumbs: ["مدیریت کاربران "],
              pageTitle: "لیست آدرس ها",
              roles: ["admin", "super admin", "operator"],
            },
          },
          // {
          //   path: "edit",
          //   name: "addressEdit",
          //   component: () => import("@/views/address/Edit.vue"),
          //   meta: {
          //     pageTitle: "ویرایش ادرس",
          //     breadcrumbs: ["ویرایش"],
          //   },
          // },
          // {
          //   path: "add",
          //   name: "addressAdd",
          //   component: () => import("@/views/address/Add.vue"),
          //   meta: {
          //     pageTitle: "افزودن ادرس",
          //     breadcrumbs: ["افزودن"],
          //   },
          // },
        ],
      },
      {
        path: "/available-cars",
        name: "availableCars",
        meta: {
          breadcrumbs: ["خودرو ها"],
          pageTitle: " لیست خودروها",
          roles: ["super admin", "admin", "operator"],
        },
        children: [
          {
            path: "",
            name: "availableCarsList",
            component: () => import("@/views/availableCars/List.vue"),
            meta: {
              pageTitle: " لیست خودروها",
              breadcrumbs: ["خودرو ها"],
              roles: ["super admin", "admin", "reporter", "operator"],
            },
          },

          {
            path: "add",
            name: "availableCarsAdd",
            component: () => import("@/views/availableCars/Add.vue"),
            meta: {
              pageTitle: "افزودن",
              breadcrumbs: ["خودرو ها"],
            },
          },
          {
            path: "availableCarsList/:id",
            name: "availableCarDetail",
            component: () => import("@/views/availableCars/Detail.vue"),
            meta: {
              pageTitle: "جزئیات خودرو",
              breadcrumbs: ["جزئیات"],
            },
          },
          {
            path: "matchCarToDriver",
            name: "matchCarToDriver",
            component: () =>
                import("@/views/availableCars/MatchCarToDriver.vue"),
            meta: {
              pageTitle: " نسبت دادن خودرو به راننده",
              breadcrumbs: ["خودرو ها"],
              roles: ["super admin", "admin", "operator"],
            },
          },
        ],
      },
      {
        path: "/notifications",
        name: "notifications",
        meta: {
          breadcrumbs: ["نوتیفیکشن "],
          pageTitle: "ایجاد پیام ",
          roles: ["super admin", "marketing"],
        },
        children: [
          {
            path: "create-notification",
            name: "push-notification",
            component: () =>
                import("@/views/notification/createNotification.vue"),
          },
        ],
      },
      {
        path: "/drivers",
        name: "drivers",
        meta: {
          breadcrumbs: [" رانندگان"],
          pageTitle: "لیست رانندگان",
          roles: [
            "super admin",
            "admin",
            "driver admin",
            "warehouse-keeper",
            "operator",
          ],
        },
        children: [
          {
            path: "list",
            name: "driver-list",
            component: () => import("@/views/drivers/DriversList.vue"),
            meta: {
              roles: [
                "super admin",
                "admin",
                "driver admin",
                "warehouse-keeper",
              ],
            },
          },
          {
            path: "map",
            name: "drivers-map",
            component: () => import("@/views/drivers/DriverLocation.vue"),
            meta: {
              pageTitle: "موقعیت مکانی خودرو ها ",
              breadcrumbs: ["رانندگان"],
              roles: [
                "super admin",
                "admin",
                "driver admin",
                "operator",
                "warehouse-keeper",
              ],
            },
          },
          {
            path: "neshanmap",
            name: "neshanmap",
            component: () => import("@/views/drivers/neshanMap.vue"),
            meta: {
              pageTitle: "نقشه نشان ",
              breadcrumbs: ["نقشه"],
              roles: ["super admin"],
            },
          },
          {
            path: "dailyDriverOrder",
            name: "daily-driver-order",
            component: () => import("@/views/drivers/dailyDriver.vue"),
            meta: {
              pageTitle: "کارکرد رانندگان",
              breadcrumbs: ["گزارش های عملکرد"],
              roles: ["super admin", "admin"],
            },
          },
          {
            path: "monthly-driver-attendance",
            name: "monthly-driver-attendance",
            component: () =>
                import("@/views/drivers/singleDriverAttendance.vue"),
            meta: {
              pageTitle: "گزارش کارکرد ماهانه راننده",
              breadcrumbs: ["گزارش های عملکرد"],
              roles: ["super admin", "admin"],
            },
          },
          {
            path: "driver-attendance-report",
            name: "driver-attendance-report",
            component: () =>
                import("@/views/drivers/DriverAttendanse.vue"),
            meta: {
              pageTitle: "جزییات گزارش کارکرد رانندگان",
              breadcrumbs: ["گرارش های عملکرد"],
              roles: ["super admin", "admin" , "operator"],
            },
          },

        ],
      },
      {
        path: "/warehouses",
        name: "warehouses",
        meta: {
          breadcrumbs: ["مدیریت انبار ها"],
          pageTitle: "انبارها",
          roles: ["super admin", "admin", "operator",'reporter'],
        },
        children: [
          {
            path: "",
            name: "warehousesList",
            component: () => import("@/views/warehouses/List.vue"),
            meta: {
              pageTitle: "لیست انبارها",
              roles: ["super admin", "admin", "operator", "reporter"],
            },
          },
          {
            path: "edit/:id",
            name: "warehousesEdit",
            component: () => import("@/views/warehouses/Edit.vue"),
            meta: {
              pageTitle: "ویرایش انبار",
              breadcrumbs: ["ویرایش"],
            },
          },
          {
            path: ":id",
            name: "warehousesDetail",
            component: () => import("@/views/warehouses/Detail.vue"),
            meta: {
              pageTitle: "جزئیات انبار",
              breadcrumbs: ["جزئیات"],
            },
          },
          {
            path: ":id/deliveries",
            name: "warehousesDeliveryDetail",
            component: () =>
                import("@/views/warehouses/components/DeliveryDetail.vue"),
            meta: {
              pageTitle: "جزئیات تحویلی",
              breadcrumbs: ["جزئیات"],
            },
          },
          {
            path: "/warehouses/add",
            name: "warehousesAdd",
            component: () => import("@/views/warehouses/Add.vue"),
            meta: {
              pageTitle: " افزودن انبار",
              breadcrumbs: ["مدیریت انبار ها"],
              roles: ["super admin", "admin", "operator"],
            },
          },
          {
            path: "/match",
            name: "warehousesMatch",
            component: () => import("@/views/warehouses/Match.vue"),
            meta: {
              pageTitle: " نسبت دادن انبار به انباردار",
              breadcrumbs: ["مدیریت انبار ها"],
              roles: ["super admin", "admin", "operator"],
            },
          },
        ],
      },
      {
        path: "/message-management",
        name: "messagesList",
        component: () => import("@/views/messagesManagement/List.vue"),
        meta: {
          pageTitle: " مدیریت  پیام ها",
          breadcrumbs: [ " مدیریت پیام ها"],
          roles: ["super admin", "admin", "operator", "marketing"],
        },
      },
      {
        path: "/phone-orders",
        name: "/phoneOrders",
        component: () => import("@/views/Order/phone-order.vue"),
        meta: {
          breadcrumbs: ["سفارش تلفنی"],
          pageTitle: "سفارش تلفنی",
          roles: ["admin", "operator"],
        },
      },
      {
        path: "/charity2",
        name: "charity2",
        meta: {
          breadcrumbs: ["خیریه"],
          pageTitle: " خیریه",
          roles: ["super admin", "admin", "operator", "marketing"],
        },
        children: [
          {
            path: "",
            name: "charityList",
            component: () =>
                import("@/views/charityAndMarketing/CharityList.vue"),
            meta: {
              pageTitle: "خیریه ها",
              breadcrumbs: ["خیریه ها"],
              roles: ["super admin", "admin", "operator", "marketing"],
            },
          },
          // {
          //   path: "edit/:id",
          //   name: "charityEdit",
          //   component: () => import("@/views/Report/financial.vue"),
          //   meta: {
          //     pageTitle: "ویرایش خیریه",
          //   },
          // },
          // {
          //   path: "add",
          //   name: "charityAdd",
          //   component: () => import("@/views/Report/financial.vue"),
          //   meta: {
          //     pageTitle: "افزودن خیریه",
          //   },
          // },
        ],
      },
      {
        path: "/visitors",
        name: "visitors",
        meta: {
          breadcrumbs: ["بازاریابی"],
          pageTitle: " بازاریابی",
          roles: ["admin", "super admin", "merketing"],
        },
        children: [
          {
            path: "reports",
            name: "visit-reports",
            component: () => import("@/views/visitor/Report.vue"),
            meta: {
              pageTitle: "بازاریابی",
              breadcrumbs: ["گزارش عملکرد ویزیتور ها"],
              roles: ["admin", "super admin", "merketing"],
            },
          },
          {
            path: "performance-reports",
            name: "visit-performancereports",
            component: () => import("@/views/visitor/PerformanceReport.vue"),
            meta: {
              pageTitle: "بازاریابی",
              breadcrumbs: ["گزارش کارکرد"],
              roles: ["admin", "super admin", "merketing"],
            },
          },
        ],
      },
      {
        path: "/static-lists",
        name: "staticLists",
        meta: {
          breadcrumbs: ["لیست های ثابت"],
          pageTitle: "لیست های ثابت",
          roles: ["admin", "super admin", "operator", "marketing"],
        },
        children: [
          {
            path: "/industries",
            name: "industries",
            component: () => import("@/views/Defs/Guild/list.vue"),
            meta: {
              pageTitle: " اصناف",
              breadcrumbs: [" لیست های ثابت"],
              roles: ["admin", "super admin", "operator", "marketing"],
            },
          },
          {
            path: "/car-types",
            name: "carTypes",
            component: () => import("@/views/Defs/CarType/list.vue"),
            meta: {
              pageTitle: " انواع خودرو ",
              breadcrumbs: ["لیست های ثابت"],
              roles: ["admin", "super admin", "operator", "marketing"],
            },
          },
        ],
      },
      {
        path: "/educational-content",
        name: "EducationalContent",
        meta: {
          breadcrumbs: ["مدیریت مطالب اموزشی"],
          pageTitle: "مدیرت مطالب اموزشی",
          roles: ["marketing"],
        },
        children: [
          {
            path: "",
            name: "EducationalContentList",
            component: () => import("@/views/EducationalContent/List.vue"),
            meta: {
              pageTitle: "مطالب آموزشی",
              breadcrumbs: ["مطالب آموزشی"],
              roles: ["marketing"],
            },
          },
          // {
          //   path: "/add-educational-content",
          //   name: "AddEducationalContent",
          //   component: () => import("@/views/Report/financial.vue"),
          //   meta: {
          //     pageTitle: "افزودن به مطالب اموزشی",
          //     breadcrumbs: ["افزودن"],
          //   },
          // },
          // {
          //   path: "edit",
          //   name: "EducationalContentEdit",
          //   component: () => import("@/views/EducationalContent/Edit.vue"),
          //   meta: {
          //     pageTitle: "ویرایش لیست مطالب آموزشی",
          //     breadcrumbs: ["ویرایش"],
          //   },
          // },
          // {
          //   path: "add",
          //   name: "EducationalContentAdd",
          //   component: () => import("@/views/EducationalContent/Edit.vue"),
          //   meta: {
          //     pageTitle: "ویرایش لیست مطالب آموزشی",
          //     breadcrumbs: ["ویرایش"],
          //   },
          // },
        ],
      },
      {
        path: "/cities",
        name: "cities",
        meta: {
          breadcrumbs: ["مدیریت شهر ها"],
          pageTitle: "شهر ها",
          roles: ["marketing", "super admin", "operator"],
        },
        children: [
          {
            path: "",
            name: "citiesList",
            component: () => import("@/views/cities/List.vue"),
            meta: {
              pageTitle: " لیست شهر ها",
              roles: ["marketing", "super admin", "operator"],
            },
          },


          {
            path: "regions",
            name: "rigionList",
            component: () => import("@/views/cities/regions.vue"),
            meta: {
              pageTitle: " لیست مناطق",
              roles: ["marketing", "super admin", "operator"],
            },
          },




          {
            path: "edit",
            name: "cityedit",
            component: () => import("@/views/cities/Edit.vue"),
            meta: {
              pageTitle: "ویرایش شهر",
              breadcrumbs: ["ویرایش"],
            },
          },
          {
            path: "modalCity",
            name: "citymodal",
            component: () => import("@/views/cities/modals/cityModal.vue"),
            meta: {
              pageTitle: " شهر",
              breadcrumbs: ["ویرایش"],
            },
          },
        ],
      },
      {
        path: "/maps",
        name: "maps",
        meta: {
          breadcrumbs: ["نقشه ها"],
          pageTitle: "نقشه ها",
        },
        children: [
          {
            path: "/user-map",
            name: "UserMap",
            component: () => import("@/views/maps/UserMap.vue"),
            meta: {
              pageTitle: "نقشه کاربران",
              breadcrumbs: ["نقشه کاربران"],
            },
            // children: [
            //   {
            //     path: "edit",
            //     name: "UserMapEdit",
            //     component: () => import("@/views/Report/financial.vue"),
            //     meta: {
            //       pageTitle: "ویرایش ",
            //       breadcrumbs: ["ویرایش"],
            //     },
            //   },
            //   {
            //     path: "/:id",
            //     name: "UserMapDetail",
            //     component: () => import("@/views/Report/financial.vue"),
            //     meta: {
            //       pageTitle: "جزئیات",
            //       breadcrumbs: ["جزئیات"],
            //     },
            //   },
            // ],
          },
          {
            path: "/request-map",
            name: "RequestMap",
            component: () => import("@/views/maps/RequestMap.vue"),
            meta: {
              pageTitle: "نقشه درخواست ها",
              breadcrumbs: ["نقشه درخواست ها"],
            },
            // children: [
            //   {
            //     path: "edit",
            //     name: "RequestMapEdit",
            //     component: () => import("@/views/Report/financial.vue"),
            //     meta: {
            //       pageTitle: "ویرایش ",
            //       breadcrumbs: ["ویرایش"],
            //     },
            //   },
            //   {
            //     path: "/:id",
            //     name: "RequestMapDetail",
            //     component: () => import("@/views/Report/financial.vue"),
            //     meta: {
            //       pageTitle: "جزئیات",
            //       breadcrumbs: ["جزئیات"],
            //     },
            //   },
            // ],
          },
          {
            path: "/car-map",
            name: "CarMap",
            component: () => import("@/views/maps/CarMap.vue"),
            meta: {
              pageTitle: "نقشه خودروها",
              breadcrumbs: ["نقشه خودروها"],
            },
          },
          {
            path: "/warehouse-map",
            name: "WarehouseMap",
            component: () => import("@/views/maps/WarehouseMap.vue"),
            meta: {
              pageTitle: "نقشه انبارها",
              breadcrumbs: ["نقشه انبارها"],
            },
            // children: [
            //   {
            //     path: "/:id",
            //     name: "RequestMapDetail",
            //     component: () => import("@/views/Report/financial.vue"),
            //     meta: {
            //       pageTitle: "جزئیات",
            //       breadcrumbs: ["جزئیات"],
            //     },
            //   },
            // ],
          },
        ],
      },
    ],
  },

  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
            import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Sign In",
        },
      },
      {
        path: "/:company/sign-in",
        name: "company-sign-in",
        component: () =>
            import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Sign In",
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
            import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
        meta: {
          pageTitle: "Sign Up",
        },
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
            import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
        meta: {
          pageTitle: "Password reset",
        },
      },
    ],
  },
  {
    path: "/charity",
    name: "charity",
    meta: {
      breadcrumbs: ["خیریه"],
      pageTitle: " خیریه",
      roles: ["super admin", "admin", "operator", "marketing"],
    },
    children: [
      {
        path: "",
        name: "charityList",
        component: () => import("@/views/charityAndMarketing/CharityList.vue"),
        meta: {
          pageTitle: "خیریه ها",
          breadcrumbs: ["خیریه ها"],
          roles: ["super admin", "admin", "operator", "marketing"],
        },
      },
      {
        path: "/restaurantList",
        name: "restaurantList",
        component: () =>
            import("@/views/charityAndMarketing/RestaurantList.vue"),
        meta: {
          pageTitle: "لیست رستوران ها",
          breadcrumbs: ["لیست رستوران ها"],
          roles: ["super admin", "admin", "operator", "marketing"],
        },
      },
      {
        path: "/feedList",
        name: "feedList",
        component: () => import("@/views/charityAndMarketing/FeedtList.vue"),
        meta: {
          pageTitle: "لیست اطعام",
          breadcrumbs: ["لیست اطعام"],
          roles: ["super admin", "admin", "operator", "marketing"],
        },
      },
      {
        path: "/requestList",
        name: "requestList",
        component: () => import("@/views/charityAndMarketing/RequestList.vue"),
        meta: {
          pageTitle: "لیست درخواست ها",
          breadcrumbs: ["لیست درخواست ها"],
          roles: ["super admin", "admin", "operator", "marketing"],
        },
      },
      // {
      //   path: "edit/:id",
      //   name: "charityEdit",
      //   component: () => import("@/views/Report/financial.vue"),
      //   meta: {
      //     pageTitle: "ویرایش خیریه",
      //   },
      // },
      // {
      //   path: "add",
      //   name: "charityAdd",
      //   component: () => import("@/views/Report/financial.vue"),
      //   meta: {
      //     pageTitle: "افزودن خیریه",
      //   },
      // },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/crafted/authentication/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/crafted/authentication/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const configStore = useConfigStore();
  // @ts-ignore
  const user: any = JSON.parse(localStorage.getItem("user"));

  if (user) {
    // eslint-disable-next-line no-prototype-builtins
    if (user.hasOwnProperty("id")) {
      authStore.setUser(user);
    }
  } else {
    //@ts-ignore
    window.location = "/sign-in";
    authStore.logout();
  }

  // current page view title
  document.title = to.meta.pageTitle
      ? `${to.meta.pageTitle} - ${import.meta.env.VITE_APP_NAME}`
      : `${import.meta.env.VITE_APP_NAME}`;

  // reset config to initial state
  configStore.resetLayoutConfig();

  // verify auth token before each page change
  authStore.verifyAuth();

  // before page access check if page requires authentication
  // if (to.meta.middleware == "auth") {
  //   let hasRole = false;
  //   if (authStore.isAuthenticated) {
  //     for (const role of authStore.user.roles){
  //       if(role.name!='user'){
  //         hasRole=true;
  //         break;
  //       }
  //     }
  //     if(!hasRole){
  //       next({ name: "404"});
  //     }else{
  //       if(!to.meta.roles){
  //         next();
  //         return;
  //       }
  //
  //       else{
  //         hasRole=false;
  //         for (const role of to.meta.roles as []){
  //           authStore.user.roles.forEach((userRole)=>{
  //             if(userRole.name==role)
  //               hasRole=true;
  //           })
  //         }
  //       }
  //       if(hasRole){
  //         next();
  //         return;
  //       }
  //       else{
  //         const toaster = createToaster({
  //           type: 'error',
  //           position: 'top-right',
  //         });
  //
  //         toaster.show('شما دسترسی لازم برای این بخش را ندارید');
  //       }
  //
  //     }
  //   } else {
  //     next({ name: "sign-in" });
  //     return;
  //   }
  // } else {
  //   next();
  //   return;
  // }
  if (to.meta.middleware == "auth") {
    if (authStore.isAuthenticated) {
      next();
    } else {
      next({ name: "sign-in" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;

